// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';

// Impor semua komponen layar utama
import Menu from './components/Menu'; // Ini akan otomatis mengambil index.js
import MathModeMenu from './components/MathModeMenu';
import LevelMenu from './components/LevelMenu';
import Countdown from './components/Countdown';
import GameScreen from './components/GameScreen';
import FaunaRaceGame from './components/FaunaRace/FaunaRaceGame';
import PinisiKataGame from './components/PinisiKata/PinisiKataGame';
import PilahSampahGame from './components/PilahSampah/PilahSampahGame';

// Impor ikon
import homeIcon from './assets/icon_home.png';

function App() {
    // State untuk mengontrol layar mana yang aktif
    const [screen, setScreen] = useState('menu'); // 'menu', 'mathMode', 'fauna-race', dll.
    
    // State untuk menyimpan pilihan pengguna
    const [gameType, setGameType] = useState(null);
    const [mathMode, setMathMode] = useState(null);
    const [level, setLevel] = useState(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    // Fullscreen handler
    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err => console.error(err));
        } else {
            document.exitFullscreen();
        }
    };
    
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
    }, []);

    // --- Handlers untuk Navigasi ---

    // ==========================================================
    // PERBAIKAN UTAMA #1: Logika navigasi yang lebih pintar
    // ==========================================================
    const handleSelectGame = (type) => {
        setGameType(type);
        if (type === 'fauna-race') { setScreen('fauna-race'); }
        else if (type === 'pinisi-kata') { setScreen('pinisi-kata'); }
        else if (type === 'pilah-sampah') { setScreen('pilah-sampah'); } // <-- Tambahkan ini
        else { setScreen('mathMode'); }
    };

    const handleSelectMode = (mode) => {
        setMathMode(mode);
        setScreen('level');
    };

    const handleSelectLevel = (lvl) => {
        setLevel(lvl);
        setScreen('countdown');
    };

    const handleCountdownFinish = () => {
        setScreen('game'); // Layar 'game' sekarang khusus untuk game matematika
    };

    const handleGoHome = () => {
        setScreen('menu');
        // Reset semua pilihan
        setGameType(null);
        setMathMode(null);
        setLevel(null);
    };

    const handlePlayAgain = () => {
        // Logika ini untuk game matematika
        setScreen('countdown');
    };
    
    // ==========================================================
    // PERBAIKAN UTAMA #2: Logika render yang lebih bersih
    // ==========================================================
    const renderScreen = () => {
        switch (screen) {
            case 'menu':
                return <Menu onSelectGame={handleSelectGame} />;
            
            // Alur Game Matematika
            case 'mathMode':
                return <MathModeMenu gameType={gameType} onSelectMode={handleSelectMode} onBack={handleGoHome} />;
            case 'level':
                return <LevelMenu mathMode={mathMode} onSelectLevel={handleSelectLevel} onBack={() => setScreen('mathMode')} />;
            case 'countdown':
                return <Countdown onFinish={handleCountdownFinish} />;
            case 'game':
                return <GameScreen gameType={gameType} mathMode={mathMode} level={level} onPlayAgain={handlePlayAgain} />;

            // Alur Game Fauna Race
            case 'fauna-race':
                return <FaunaRaceGame onGoHome={handleGoHome} />;

                 // Alur Game Pinisi Kata
            case 'pinisi-kata': // <-- Tambahkan case ini
                return <PinisiKataGame onGoHome={handleGoHome} />;

            case 'pilah-sampah': // <-- Tambahkan ini
                return <PilahSampahGame onGoHome={handleGoHome} />;
            
            default:
                return <Menu onSelectGame={handleSelectGame} />;
        }
    };

    return (
        <>
            {renderScreen()}
            
            {/* Tombol Fullscreen & Home hanya akan muncul untuk layar game matematika */}
            {screen === 'game' && (
                <>
                    <button id="fullscreenBtn" className="fullscreen-btn" onClick={toggleFullscreen} title="Toggle Fullscreen">
                        {!isFullscreen ? (
                            <svg className="fullscreen-icon expand" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                            </svg>
                        ) : (
                            <svg className="fullscreen-icon collapse" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
                            </svg>
                        )}
                    </button>
                    <button id="homeBtn" className="home-btn" onClick={handleGoHome} title="Menu Utama" style={{display: 'flex'}}>
                         <img src={homeIcon} alt="Home" className="home-icon"/>
                    </button>
                </>
            )}
        </>
    );
}

export default App;